import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

const getCompanyId = () =>
  JSON.parse(localStorage.getItem("sdfUser"))?.company_id;

export const fromWithCompany = (table) => {
  try {
    const company_id = getCompanyId();
    
    if (!company_id) {
      const mockQuery = {
        select: () => mockQuery,
        eq: () => mockQuery,
        neq: () => mockQuery,
        in: () => mockQuery,
        order: () => mockQuery,
        limit: () => mockQuery,
        single: () => mockQuery,
        maybeSingle: () => mockQuery,
        then: function(resolve, reject) {
          return Promise.resolve({ data: null, error: null }).then(resolve, reject);
        },
        catch: function(reject) {
          return Promise.resolve({ data: null, error: null }).catch(reject);
        }
      };
      return mockQuery;
    }
    
    return supabase.from(table).select("*").eq("company_id", company_id);
  } catch (error) {
    console.error("Error in fromWithCompany:", error);
    const mockQuery = {
      select: () => mockQuery,
      eq: () => mockQuery,
      neq: () => mockQuery,
      in: () => mockQuery,
      order: () => mockQuery,
      limit: () => mockQuery,
      single: () => mockQuery,
      maybeSingle: () => mockQuery,
      then: function(resolve, reject) {
        return Promise.resolve({ data: null, error: null }).then(resolve, reject);
      },
      catch: function(reject) {
        return Promise.resolve({ data: null, error: null }).catch(reject);
      }
    };
    return mockQuery;
  }
};
